import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useLang } from "@/i18n";

export default function Reviews() {
  const { t } = useLang();
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32 border-b border-[#27272A]"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
        <div>
          <p className="font-satoshi font-bold text-xs tracking-[0.3em] uppercase text-accent mb-5 flex items-center gap-2">
            <span className="w-4 h-4 bg-brand" /> {t.reviews.label}
          </p>
          <h2 className="font-cabinet font-black uppercase text-6xl md:text-8xl tracking-tighter leading-[0.8]">
            {t.reviews.h1}
            <br />
            <span className="text-outline-accent">{t.reviews.h2}</span>
          </h2>
        </div>
      </div>

      <div className="grid md:grid-cols-3 border-t border-l border-[#27272A]">
        {t.reviews.items.map((r, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
            data-testid={`review-${i}`}
            className="group flex flex-col justify-between gap-10 p-8 md:p-10 border-b border-r border-[#27272A] hover:bg-[#0c0c0e] transition-colors duration-300"
          >
            <div>
              <Quote className="text-brand mb-6 group-hover:scale-110 origin-left transition-transform duration-300" size={34} />
              <blockquote className="font-cabinet font-bold text-2xl md:text-3xl tracking-tight leading-tight text-[#fafafa]">
                “{r.quote}”
              </blockquote>
            </div>
            <figcaption className="flex items-center justify-between gap-4 pt-6 border-t border-[#27272A]">
              <div>
                <p className="font-satoshi font-bold text-base text-white">{r.name}</p>
                <p className="font-satoshi text-sm text-[#a1a1aa]">{r.role}</p>
              </div>
              <div className="flex gap-0.5 shrink-0">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="fill-brand text-brand" />
                ))}
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
